import React, { useState, useContext, useEffect } from 'react';

import Accordion from '../accordion/accordion.component';
import { BaseSelectSelector } from './select-selector.component';

import { GlobalContext } from '../../contexts/global.context';

const defaultProps = {
  value: '',
  label: 'Chart Year',
  yearsKey: 'years'
};

export default function ChartYearSelector({
  expanded,
  handleChange,
  handleChangeSelection,
  id,
  value=defaultProps.value,
  label=defaultProps.label,
  yearsKey=defaultProps.yearsKey
}) {
  const { chartData } = useContext(GlobalContext);
  const [years, setYears] = useState([]);

  useEffect(() => {
    if (chartData && yearsKey in chartData) {
      const newYears = chartData[yearsKey].map(y => ({ name: String(y), value: String(y) })).reverse();
      setYears(newYears);
      handleChangeSelection(newYears[0].value);
    } else {
      setYears([]);
      handleChangeSelection('');
    }
  }, [chartData, yearsKey]);

  return (
    <Accordion expanded={expanded === id} handleChange={handleChange} id={id} label={label} >
      <BaseSelectSelector
        value={value}
        handleChangeSelection={handleChangeSelection}
        options={years}
      />
    </Accordion>
  );
}

export { defaultProps };